/**
 * Spaceship — Generated by hearth-asset-pipeline
 * Furniture: 2×2 tiles
 * Generated: 2026-04-11T05:57:10.455Z
 *
 * This is a procedural isometric furniture renderer produced from a 3D model.
 * Integrates with Hearth's renderFurniture() dispatch and isoBox primitives.
 */

import { renderIsoAsset, type IsoAssetDef } from "../../render/iso-engine.js";

/** Furniture registry metadata */
export const Spaceship_META = {
  id: "Spaceship",
  name: "Spaceship",
  tileWidth: 2,
  tileHeight: 2,
  isoWidth: 53,
  isoDepth: 40,
  canonicalRot: 0 as const,
  interactionAnchors: [
    { type: "use_point", localWx: 1, localWy: 0, elevation: 0, faceDir: "S" },
  ],
} as const;

/** Declarative asset definition — pure data, no rendering code */
export const Spaceship_DEF: IsoAssetDef = {
  id: "Spaceship",
  name: "Spaceship",
  tile: [2, 2],
  geometry: { w: 42, d: 64, h: 15 },
  faces: {
    top: {
      base: "#333333",
      palette: ["#333333", "#444343", "#4b4b4b", "#2c2c2c", "#3c3c3c"],
      metalness: 0.75,
      roughness: 0.31,
      opacity: 1.00,
      emissive: "#087f83",
      materialType: "metal",
      gradient: { stops: [[0.00, "#5c7a83"], [0.33, "#556062"], [0.67, "#515046"], [1.00, "#63675d"]], strength: 0.127 },
      grain: { scale: 2.0, contrast: 0.300, angle: 0 },
      specular: { x: 0.49, y: 0.57, radius: 0.52, intensity: 0.79 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
    left: {
      base: "#232323",
      palette: ["#232323", "#1c1c1c", "#141414", "#2a2a2b", "#419ebc"],
      metalness: 0.64,
      roughness: 0.30,
      opacity: 1.00,
      emissive: "#076a6d",
      materialType: "metal",
      gradient: { stops: [[0.00, "#272f2e"], [0.33, "#282926"], [0.67, "#394544"], [1.00, "#415355"]], strength: 0.677 },
      grain: { scale: 2.0, contrast: 0.300, angle: 90 },
      specular: { x: 0.61, y: 0.39, radius: 0.43, intensity: 0.80 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
    right: {
      base: "#1b1b1b",
      palette: ["#1b1b1b", "#242424", "#141414", "#3b3b3b", "#323333"],
      metalness: 0.67,
      roughness: 0.31,
      opacity: 1.00,
      materialType: "metal",
      gradient: { stops: [[0.00, "#242424"], [0.33, "#323123"], [0.67, "#4f4b3e"], [1.00, "#514831"]], strength: 0.660 },
      specular: { x: 0.55, y: 0.64, radius: 0.52, intensity: 0.80 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
  },
  anchors: [
    { type: "use_point", wx: 1, wy: 0, elevation: 0, dir: "S" },
  ],
};

/**
 * Render Spaceship via the shared isometric material engine.
 * Drop-in compatible with Hearth's renderFurniture() dispatch.
 */
export function renderSpaceship(
  ctx: CanvasRenderingContext2D,
  screenX: number,
  screenY: number,
  direction: 0 | 1 | 2 | 3,
  state: Record<string, unknown>,
  time: number,
): void {
  renderIsoAsset(ctx, Spaceship_DEF, screenX, screenY, direction, state, time);
}